import fonts from "../../../../../../styles/fonts";
import palette from "../../../../../../styles/palette";
import position from "../../../../../../styles/position";

export default {
    wrapper: {
        ...position.absoluteFill,
        zIndex: 9999,
        textAlign: "center",
        overflow: "auto",
        backgroundColor: "white",
    } as React.CSSProperties,
    container: {
        display: "inline-block",
        width: "100%",
        maxWidth: 1000,
    } as React.CSSProperties,
    padded: {
        padding: 20,
    },
    toolBar: {
        textAlign: "left",
        marginBottom: 20
    } as React.CSSProperties,
    title: {
        ...fonts.title,
        color: palette.text.primary,
    } as React.CSSProperties,
    message: {
        ...fonts.subTitle,
        color: palette.text.secondary,
    } as React.CSSProperties,
    button: {
        marginRight: 20,
        marginBottom: 10
    } as React.CSSProperties,
    iconChevron: {
        fontSize: 24,
        marginLeft: 20,
        marginRight: 10,
    } as React.CSSProperties,
};